(() => {
 const gate=document.getElementById('alc-age-gate');if(!gate)return;
 let allowed=false;
 try{allowed=sessionStorage.getItem('alc_age_yes_session_v1')==='yes'}catch(e){}
 try{allowed=allowed||/(?:^|;\s*)alc_age_verified_session=1(?:;|$)/.test(document.cookie)}catch(e){}
 if(allowed){document.documentElement.classList.add('alc-age-confirmed');gate.hidden=true;return}
 const overflow=document.body.style.overflow;
 document.body.style.overflow='hidden';
 const yes=gate.querySelector('#alc-age-yes'),no=gate.querySelector('#alc-age-no'),buttons=[yes,no];
 gate.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();return}if(e.key!=='Tab')return;
  if(e.shiftKey&&document.activeElement===yes){e.preventDefault();no.focus()}else if(!e.shiftKey&&document.activeElement===no){e.preventDefault();yes.focus()}
 });
 yes.addEventListener('click',()=>{
  try{sessionStorage.setItem('alc_age_yes_session_v1','yes')}catch(e){}
  try{document.cookie='alc_age_verified_session=1; Path=/; SameSite=Lax'}catch(e){}
  document.documentElement.classList.add('alc-age-confirmed');
  gate.hidden=true;document.body.style.overflow=overflow
 });
 no.addEventListener('click',()=>{gate.querySelector('[data-alc-age-choices]').hidden=true;const denied=gate.querySelector('#alc-age-rejected');denied.hidden=false;denied.focus()});
 yes.focus();
})();